const READ_ONLY_BANNER_MESSAGE = `Chartlos is currently in read-only mode due to maintenance. While this is happening you can view existing charts but can't create any new chart or modify existing charts. This doesn't affect published charts.`;

const CHART_DATA_LABEL = `**Chart Data** ([TAB](https://en.wikipedia.org/wiki/Tab-separated_values), [CSV](https://en.wikipedia.org/wiki/Comma-separated_values), [JSON](https://en.wikipedia.org/wiki/JSON))`;

const ANNOTATION_CHANGED_INFO = `Because your data was updated, the points for some of your annotations no longer exist, so those annotations have been removed`;

const SAVE_ERROR = 'Publishing failed because the chart could not be saved.';

// y-axis error messages
const LOG_SCALE_ERROR =
  'Logarithmic axis never reaches or crosses zero. Please adjust the data or set the scale to linear to apply this setting.';

const BAR_CHART_Y_AXIS_MAX_ERROR = `The maximum value of the Y-axis for bar charts must be greater or equal to zero.`;
const BAR_CHART_Y_AXIS_MIN_ERROR = `The minimum value of the Y-axis for bar charts must be less or equal to zero.`;
const DESKTOP_INTERVAL_ERROR = `Please enter a positive number.`;

const INVALID_DATA =
  'We were unable to render your chart, make sure you data formatted correctly. If you need help, reach out to #chartlos channel.';

export {
  READ_ONLY_BANNER_MESSAGE,
  CHART_DATA_LABEL,
  ANNOTATION_CHANGED_INFO,
  SAVE_ERROR,
  LOG_SCALE_ERROR,
  BAR_CHART_Y_AXIS_MAX_ERROR,
  BAR_CHART_Y_AXIS_MIN_ERROR,
  DESKTOP_INTERVAL_ERROR,
  INVALID_DATA,
};
